export default function Loader() {
  return (
    <div className='w-100 my-8 d-flex align-items-center justify-content-center'>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )
}